import React from 'react';
import { defaultSettings } from './default/settings';
import { lazyLoad } from '@react-page/editor';
import { FormController } from './Controls/FormController';
import inputPlugin from '@migeran/plugins-input';
import formState from '@migeran/plugins-form-state';
import cleanForm from '@migeran/plugins-clear-form';
const Icon = lazyLoad(() => import('@mui/icons-material/CropLandscape'));
function getFieldMultiLine(originType) {
    console.log('Field type: ' + originType);
    if (originType === 'Long Text') {
        return true;
    }
    return false;
}
const createPlugin = (settings) => {
    var _a, _b;
    const mergedSettings = Object.assign(Object.assign({}, defaultSettings), settings);
    const Controls = mergedSettings.Controls;
    const Renderer = mergedSettings.Renderer;
    if (!mergedSettings.formController) {
        mergedSettings.formController = new FormController(mergedSettings.form);
    }
    const inputFieldPlugin = inputPlugin({
        formFields: mergedSettings.form.form_fields,
        inputDataChange: mergedSettings.formController.onChange.bind(mergedSettings.formController)
    });
    const formStatePlugin = formState({});
    const cleanFormPlugin = cleanForm({
        clearForm: mergedSettings.formController.cleanForm.bind(mergedSettings.formController),
        imageUploader: mergedSettings.imageUploader
    });
    const plugin = {
        formController: mergedSettings.formController,
        controls: {
            type: 'custom',
            Component: (props) => React.createElement(Controls, Object.assign({}, props, mergedSettings)),
        },
        Renderer: (props) => React.createElement(Renderer, Object.assign({}, props, mergedSettings)),
        cellPlugins: (plugins) => [
            inputFieldPlugin,
            cleanFormPlugin,
            formStatePlugin,
            ...plugins.filter((p) => !p.id.startsWith('migeran/editor/core/layout/form/')),
        ],
        id: 'migeran/editor/core/layout/form/' + mergedSettings.form.name,
        version: 1,
        title: mergedSettings.form.title + ' ' + ((_a = mergedSettings.translations) === null || _a === void 0 ? void 0 : _a.pluginName),
        description: (_b = mergedSettings.translations) === null || _b === void 0 ? void 0 : _b.pluginDescription,
        icon: React.createElement(Icon, null),
        createInitialChildren: () => {
            let partialRow = [];
            if (!settings.form.form_fields) {
                console.log('Not found form data');
                return partialRow;
            }
            settings.form.form_fields.map((field) => {
                let formData = [{
                        plugin: {
                            id: "migeran/editor/core/content/input",
                            version: 1
                        },
                        data: {
                            name: field.fieldname,
                            label: field.label,
                            type: "text",
                            required: field.reqd,
                            multiLine: getFieldMultiLine(field.fieldtype),
                            isGenerated: true,
                            defaultValue: field.default,
                        }
                    }];
                partialRow.push(formData);
            });
            let submitButton = [
                {
                    plugin: {
                        id: "migeran/editor/core/content/button",
                        version: 1
                    },
                    data: {
                        label: "Submit",
                        isSubmitButton: true,
                    }
                }
            ];
            partialRow.push(submitButton);
            let clearFormButton = [
                {
                    plugin: {
                        id: "migeran/editor/core/content/clear-form",
                        version: 1
                    },
                    data: {
                        label: "Clear",
                    }
                }
            ];
            partialRow.push(clearFormButton);
            return partialRow;
        },
        cellStyle: mergedSettings.cellStyle,
    };
    return plugin;
};
export default createPlugin;
//# sourceMappingURL=createPlugin.js.map